import { Box, CircularProgress, Typography } from "@mui/material";

interface LoadingStateProps {
  message?: string; // Tekst komunikatu ładowania
  size?: number; // Rozmiar spinnera
  minHeight?: number; // Minimalna wysokość kontenera
  showBorder?: boolean; // Czy pokazać ramkę wokół stanu ładowania
  color?: "primary" | "secondary" | "inherit"; // Kolor spinnera
  showMessage?: boolean; // Czy pokazać tekst pod spinnerem
}

// Generyczny komponent stanu ładowania - może być używany w różnych miejscach aplikacji
export default function LoadingState({
  message = "Ładowanie...",
  size = 40,
  minHeight = 200,
  showBorder = true,
  color = "primary",
  showMessage = true,
}: LoadingStateProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight,
        ...(showBorder && { border: "1px dashed #ccc", borderRadius: 1 }),
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <CircularProgress size={size} color={color} />
        {showMessage && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            {message}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
